<template>
  <div
    v-if="$localization.lang !== 'es'"
    class="period-and-currency"
  >
    <PeriodControl v-model="months" />
    <CurrencySelect v-model="currency" />
  </div>
  <div class="tariff-cards">
    <AllIncludedCard
      :currency="currency"
      :months="months"
      :discount="discount"
    />
    <RecruitingCard
      :currency="currency"
      :months="months"
      :discount="discount"
    />
    <HrCard
      :currency="currency"
      :months="months"
      :discount="discount"
    />
  </div>
</template>

<script>
import { discountByMonth } from '@/mainData';

import PeriodControl from './PeriodControl';
import AllIncludedCard from './AllIncludedCard';
import RecruitingCard from './RecruitingCard';
import HrCard from './HrCard';
import CurrencySelect from './CurrencySelect';

export default {
  name: 'TariffCalc',

  components: {
    AllIncludedCard,
    RecruitingCard,
    HrCard,
    PeriodControl,
    CurrencySelect,
  },

  data() {
    return {
      months: 3,
      currency: 'usd',
    };
  },

  computed: {
    discount() {
      return discountByMonth[this.months];
    },
  },
};
</script>

<style lang="sass" scoped>
.period-and-currency
  display: flex
  padding: 16px 0 0
  justify-content: center
.tariff-cards
  display: flex
  align-items: flex-end
  justify-content: center
  margin: 0 -8px
  padding: 48px 0 0

@media screen and (max-width: 999px)
  .tariff-cards
    display: block
    margin: 0
    padding: 32px 0 0

@media screen and (max-width: 580px)
  .period-and-currency
    flex-direction: column
    align-items: center
</style>